import { TVI_STATUS_COLORS, TVI_STATUS_TEXTS, TviStatusEnum, TVI_STATUS_TOOLTIP } from '@/constant/RETURN_TIME'
import {
  ColAntd,
  Container,
  ModeBody,
  ModeCard,
  ModeMinute,
  ModeStatus,
  ModeText,
  RowAntd,
} from './styles'
import { Tooltip } from 'antd'
import ModeSummarizeHook from './ModeSummarize.hook'
import { PeriodWithIdType } from '@/services/coverage/useCoveragesPeriod/types'

const ModeSummarize = ({
  tripStatus,
  data,
  handleOnClick,
}: {
  tripStatus?: TviStatusEnum
  data?: PeriodWithIdType[]
  handleOnClick?: (data: any) => void
}) => {
  const { calculateMinutesAndPercentage } = ModeSummarizeHook()
  const result = calculateMinutesAndPercentage(data)

  return (
    <Container>
      <RowAntd gutter={[8, 8]}>
        {Object.entries(TVI_STATUS_COLORS).map(([status, color]) => {
          return (
            <ColAntd flex={2.4} key={status}>
              <Tooltip title = {TVI_STATUS_TOOLTIP[status as TviStatusEnum]}>
              <ModeCard
                isAction={tripStatus === status}
                onClick={() => {
                  if (!handleOnClick) return
                  handleOnClick(tripStatus === status ? undefined : status)
                }}
              >
                <ModeStatus color={color} text={TVI_STATUS_TEXTS[status as TviStatusEnum]} />
                <ModeBody>
                  <ModeText>
                    <ModeMinute>{result[status]?.minutes || '0'}</ModeMinute>นาที
                  </ModeText>
                  <ModeText>
                    {result[status]?.percentage || '0'}
                    {' %'}
                  </ModeText>
                </ModeBody>
              </ModeCard>
            </Tooltip>
            </ColAntd>
          )
        })}
      </RowAntd>
    </Container>
  )
}

export default ModeSummarize
